import React from 'react';

import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import TrackerCard from './trackerCard';

const TattleSystem = ({ productSelected, tracker, rateplanTotalsList }) => {
  const {
    iotOrderDetailsSection: { labelTattleSystem, labelFillipFleet },
    contentfulValues: {
      valueNorthStarSystems,
      valueNorthStarSystemsFarmAndRanch,
      valueFillipFleet
    }
  } = useLocalizedStringsContext();

  const { tattleSystemTracker, additionalServicesTotal } = tracker;
  const rateplanTotalsListClone = [
    ...rateplanTotalsList,
    ...(([valueNorthStarSystems, valueNorthStarSystemsFarmAndRanch].includes(
      productSelected
    ) && [
      {
        name: 'one time delivery charges',
        total: tattleSystemTracker
      }
    ]) ||
      [])
  ];
  const props = {
    title: productSelected === valueFillipFleet ? labelFillipFleet : labelTattleSystem,
    hardwareList: {},
    rateplanTotalsList: rateplanTotalsListClone,
    rateplanTotal: tattleSystemTracker,
    ...(additionalServicesTotal && { additionalServicesTotal })
  };

  return <TrackerCard {...props} />;
};

TattleSystem.propTypes = {
  productSelected: PropTypes.string.isRequired,
  tracker: PropTypes.shape({
    tattleSystemTracker: PropTypes.number,
    assetTrackerRateplanTotal: PropTypes.number,
    additionalServicesTotal: PropTypes.number,
    addonsTotal: PropTypes.number,
    vehiclesTotal: PropTypes.number
  }).isRequired,
  rateplanTotalsList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      total: PropTypes.number
    })
  ).isRequired
};

export default TattleSystem;
